function makeRequestOffline() {
	let fakeResp = {};
	var myModule;
	myModule = require('./mockDataGaviota');
	fakeResp = JSON.parse(JSON.stringify(myModule.mockDataGaviota));
	return fakeResp;
}
exports.makeRequestOffline = makeRequestOffline;
